export class AttachmentQuotation {

    constructor(
        public quotationId: number,
        public file: File
    ){}
}
